// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const PromotionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #eecf46;
  width: fit-content;
  padding: 2px;
  border-radius: 4px;

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 2px 4px;
  }
`;

export const RecommendationsPromotionsContainer = styled.div`
  font-family: Nunito;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgb(200, 16, 46);
  margin-top: 8px;

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 2px 4px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 11px;
  }
`;

export const Promotion = styled.div`
  cursor: pointer;

  .promo_message_anchor {
    font-family: Nunito;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }

  .underLine {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;
